export default function ClarksvilleMistakesSection() {
  const mistakes = [
    {
      icon: "ri-time-line",
      title: "Waiting Until Orders Drop",
      description:
        "The biggest mistake Fort Campbell families make is waiting for deployment orders to start the passport process. Orders can drop with 72 hours notice — but passports take weeks.",
      fix: "Apply for your passport before orders arrive. Keep your passport current at all times.",
    },
    {
      icon: "ri-id-card-line",
      title: "Forgetting Dependent IDs",
      description:
        "Military family members are often surprised that a dependent ID card alone is not sufficient proof of citizenship. You still need a birth certificate and other documents.",
      fix: "Gather original birth certificates for all family members before your appointment.",
    },
    {
      icon: "ri-camera-line",
      title: "Non-Compliant Photos",
      description:
        "Passport photos with glasses, hats, or off-center composition cause automatic rejection. We see this most with self-taken photos or convenience store machines.",
      fix: "Use our professional passport photo service to guarantee compliance the first time.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Driving to Nashville for Nothing",
      description:
        "Atlanta Passport Agency appointments are often sold out 2-3 weeks in advance. Many Clarksville residents drive the 50 miles only to find no appointments available.",
      fix: "Call us first. We eliminate the 100-mile round trip and guarantee your timeline.",
    },
    {
      icon: "ri-file-damage-line",
      title: "Incomplete or Wrong Forms",
      description:
        "DS-11 vs DS-82 confusion is extremely common. Using the wrong form wastes weeks. We review your entire application before submission.",
      fix: "Let our experts determine the right form based on your specific situation.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "Missing the 6-Month Rule",
      description:
        "Many countries require your passport to be valid for at least 6 months beyond your return date. A passport expiring in 3 months can get you denied boarding.",
      fix: "We check your expiration date against your destination's requirements before processing.",
    },
  ];

  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Mistakes Clarksville Families Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            We've seen every possible passport mistake. Here are the most common ones we prevent for Fort Campbell families.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((mistake, index) => (
            <div key={index} className="bg-white rounded-xl p-7">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-50 mb-5">
                <i className={`${mistake.icon} text-red-400 text-xl`}></i>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">{mistake.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{mistake.description}</p>
              <div className="flex items-start gap-2 bg-[#F7F8FA] p-3 rounded-lg">
                <i className="ri-lightbulb-line text-[#F6C344] text-sm mt-0.5 flex-shrink-0"></i>
                <p className="text-gray-600 text-xs leading-relaxed">{mistake.fix}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}